// extracted by mini-css-extract-plugin
export default {"upload":"style_upload__0Kexc","suggestion":"style_suggestion__g5zY0","suggestion-list":"style_suggestion-list__aDonN","suggestion-item":"style_suggestion-item__hHozT"};